module.exports = __webpack_public_path__ + "img/domestic-1981-yanan.71dd9a3e.jpg";